import { jsx as _jsx } from "react/jsx-runtime";
const PATH = {
  left: 'm20.5 7-9 9 9 9',
  right: 'm11.5 7 9 9-9 9'
};
const Chevron = ({
  direction,
  size = 20
}) => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  width: size,
  height: size,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true",
  focusable: "false",
  children: /*#__PURE__*/_jsx("path", {
    d: PATH[direction]
  })
});
export default Chevron;